module.exports = __webpack_public_path__ + "a3cc4f2baef371ec0ccba4b648084fb6.svg";